import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

const useDeleteDocumentQuery = () => {
  const { mutateAsync, isLoading } = useMutation((documentId: string) =>
    api.delete(API_URL.DOCUMENTS_BY_DOCUMENT_ID(documentId))
  );

  return {
    deleteDocument: mutateAsync,
    isDeleteDocumentLoading: isLoading,
  };
};

export default useDeleteDocumentQuery;
